import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { Sequence } from '../models/séquence.model';
import { avecMéthodesSequences } from './sequence.methods';

export const SequenceStore = signalStore(
  { providedIn: 'root' },
  withEntities<Sequence>(),
  withSelectedEntity(),
  avecMéthodesSequences(),
);
